// Canonical approved merchant / seller facts (FOP). Do not duplicate elsewhere.
export const STORE_INFO = {
  name: "Скарби Азії / AsiaStyle",
  slogan: "Скуштуй Азію на смак!",
  tagline: "Оригінальні азійські смаки з доставкою по Україні",
  phone: "0937872434",
  phoneTel: "+380937872434",
  phoneDisplay: "+380937872434",
  email: "AsiaStyle.in.ua@gmail.com",
  /** Owner-confirmed Seller address (COMMERCE-R5.2). Supersedes Білогородська. */
  address: "м. Київ, вул. Генерала Алмазова 4, кв. 15",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=%D0%BC.%20%D0%9A%D0%B8%D1%97%D0%B2%2C%20%D0%B2%D1%83%D0%BB.%20%D0%93%D0%B5%D0%BD%D0%B5%D1%80%D0%B0%D0%BB%D0%B0%20%D0%90%D0%BB%D0%BC%D0%B0%D0%B7%D0%BE%D0%B2%D0%B0%204",
  workingHours: "Вт–Нд 09:00–18:00",
  dayOff: "Пн — вихідний",
  scheduleLine:
    "Графік роботи: Вт–Нд, 09:00–18:00. Пн — вихідний.\nЗамовлення, отримані після 18:00 або у вихідний, опрацьовуємо за можливості; інакше — найближчого робочого дня.",
  /** Owner-confirmed registered FOP legal name (LEGAL-OFFER-001-P0). Do not shorten to initials. */
  merchantName: "ФОП Лиско Ярослав Юрійович",
  merchantGroup: "3",
  edrpou: "3163522910",
  bank: "ПриватБанк",
  iban: "UA323052990000026009026243254",
  ibanDisplay: "UA32 305299 0000 0260 0902 6243 254",
  managerTelegram: null as string | null,
  deliveryPayment:
    "Оплата — банківський переказ на рахунок (IBAN). Доставка — Нова Пошта.",
  social: {
    instagram: "https://www.instagram.com/asia.style.foods/" as string | null,
    youtube: null as string | null,
    tiktok: null as string | null,
  },
} as const;

export function formatSellerPaymentRequisitesText(lang: "ua" | "en" = "ua"): string {
  if (lang === "en") {
    return [
      `Recipient: ${STORE_INFO.merchantName}`,
      `Tax ID / EDRPOU: ${STORE_INFO.edrpou}`,
      `Bank: ${STORE_INFO.bank}`,
      `IBAN: ${STORE_INFO.ibanDisplay}`,
    ].join("\n");
  }
  return [
    `Отримувач: ${STORE_INFO.merchantName}`,
    `ЄДРПОУ / ІПН: ${STORE_INFO.edrpou}`,
    `Банк: ${STORE_INFO.bank}`,
    `IBAN: ${STORE_INFO.ibanDisplay}`,
  ].join("\n");
}

export function formatSellerContactsText(lang: "ua" | "en" = "ua"): string {
  if (lang === "en") {
    return [
      `Phone: ${STORE_INFO.phoneDisplay}`,
      `Email: ${STORE_INFO.email}`,
      `Address: ${STORE_INFO.address}`,
    ].join("\n");
  }
  return [
    `Телефон: ${STORE_INFO.phoneDisplay}`,
    `Email: ${STORE_INFO.email}`,
    `Адреса: ${STORE_INFO.address}`,
  ].join("\n");
}
